module.exports = __webpack_public_path__ + "media/images/slideshowGray-38bc8e7b6c3052ecc7461913006476c3.svg";